import React, { useState, useEffect, useCallback } from "react";
import { Button, CommonModal, CoreLoader, Dropdown, Input, Label } from "common/components";
import { getFirstMondayOfMonth } from "utils/dateFunctions";
import apiManager from "networking/baseAPIManager";
import { SubHeader } from "UI_Components";
import { useLocation } from "react-router-dom";
import "../../../../assets/style/Responsive.css";
import { EmpRawData, MainContentReport, SearchFilter } from "Components/AttendaceReport";
import { WeeklyAttendance } from "Components/AttendaceReport/WeeklyAttendance";
import moment from "moment";

function AttendanceReport() {
  const [loading, setLoading] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [viewMode, setViewMode] = useState("monthly");
  const [titleData, setTitleData] = useState({});
  const [reportData, setReportData] = useState([]);
  const [message, setMessage] = useState("");
  const [showWeeklyMonthlyData, setWeeklyMonthlyData] = useState([]);
  const [filterData, setFilterData] = useState({
    year: new Date().getFullYear(),
    month: moment().format("MMMM"),
  });
  const [startDate, setStartDate] = useState({});
  const [open, setOpen] = useState(false);
  const [nameOption, setNameOption] = useState({});
  const [nameOptionValue, setNameOptionValue] = useState("");
  const [attendanceOptionValue, setAttendanceOptionValue] = useState("");
  const [optionDate, setOptionDate] = useState("");

  const monthNumber = moment().month(filterData.month).format("M");
  const today = moment().format("YYYY-MM-DD");
  const firstDayOfMonth = moment().startOf("month").format("YYYY-MM-DD");

  useEffect(() => {
    fetchTitleData();
    updateStartDate(filterData);
    fetchReportMonthlyData(filterData);
  }, []);

  useEffect(() => {
    updateStartDate(filterData);
    if (viewMode === "monthly") {
      fetchReportMonthlyData(filterData);
    } else {
      fetchReportWeeklyData();
    }
  }, [filterData, viewMode]);

  const updateStartDate = (filterData) => {
    const startDateData = getFirstMondayOfMonth(filterData.year, moment().month(filterData.month).toDate().getMonth());
    setStartDate(startDateData);
  };

  const fetchTitleData = () => {
    setLoading(true);
    apiManager
      .employeecount()
      .then((response) => {
        setLoading(false);
        setTitleData(response.data);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  const fetchReportMonthlyData = () => {
    setLoading(true);
    apiManager
      .attendanceList({ month: monthNumber, year: filterData.year })
      .then((response) => {
        setLoading(false);
        setReportData(response?.data);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
        setMessage("No Data Available");
      });
  };

  const fetchReportWeeklyData = () => {
    setLoading(true);
    apiManager
      .WeeklyAttendance()
      .then((response) => {
        setLoading(false);
        setWeeklyMonthlyData(response.data);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
        setMessage("No Data Available");
      });
  };

  const updateEmployeeAttendance = () => {
    let payload = {
      empid: nameOptionValue,
      date: optionDate,
      status: attendanceOptionValue,
    };
    apiManager
      .updateAttendance(payload)
      .then((response) => {
        setOpen(false);
        fetchReportMonthlyData();
        setOptionDate("");
        setAttendanceOptionValue("");
        setNameOptionValue("");
      })
      .catch((error) => {
        console.log(error, "errorData");
      });
  };
  const handleViewModeToggle = () => {
    const newViewMode = viewMode === "monthly" ? "weekly" : "monthly";
    setViewMode(newViewMode);
    if (newViewMode === "weekly") {
      fetchReportWeeklyData();
    } else {
      fetchReportMonthlyData();
    }
  };

  const handleYearChange = (event) => {
    setFilterData({ ...filterData, year: parseInt(event.target.value) });
  };

  const getYearOptions = useCallback(() => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 6 }, (_, i) => currentYear - i).map((year) => ({
      value: year,
      label: year.toString(),
    }));
  }, []);

  const getMonthOptions = useCallback(() => {
    return moment.months().map((month) => ({
      value: month,
      label: month,
    }));
  }, []);

  const handleMonthChange = (event) => {
    setFilterData({ ...filterData, month: event.target.value });
  };

  useEffect(() => {
    if (Array.isArray(reportData) && reportData?.length > 0) {
      const result = reportData.filter((rowObj) => {
        return (
          rowObj.employeeID.toLowerCase().includes(searchString.toLowerCase()) ||
          rowObj.firstname.toLowerCase().includes(searchString.toLowerCase())
        );
      });
      setReportData(result);
    }
  }, [searchString, reportData]);

  useEffect(() => {
    if (reportData?.length > 0) {
      const options = reportData.map((data) => ({
        id: data._id,
        name: `${data.firstname} ${data.lastname}`,
      }));

      setNameOption(options);
    }
  }, [reportData]);

  const attendanceTypeOption = [
    {
      id: true,
      name: "persent",
    },
    {
      id: false,
      name: "absent",
    },
  ];
  const renderData = () => {
    return [
      { title: "Total employee", number: `(${titleData.totalEmployeeCount || 0})` },
      { title: "Present", number: `${titleData.TotalEmployeePresent || 0}` },
      { title: "Absent", number: `${titleData.TotalEmployeeAbsent || 0}` },
      { title: "Govt. holidays", number: `${titleData.totalEmployeeLeaveToday || 0}` },
    ].map((item, index) => <EmpRawData title={item.title} number={item.number} key={index} />);
  };

  return (
    <div>
      <SubHeader location={useLocation()} />
      <div className="container-fluid">
        <div className="row pt-3">
          <div className="col-lg-4 col-md-4 col-sm-12">
            <SearchFilter data={searchString} setSearchString={setSearchString} placeholder={"Name or EmpId"} />
          </div>
          <div className="col-lg-8 col-md-8  col-sm-12">
            <div className="row">
              <Dropdown
                parentclasses="col-lg-3 col-md-4 col-sm-6 mon-14"
                value={filterData.month}
                onChange={handleMonthChange}
                options={getMonthOptions()}
                placeholder="Month"
              />
              <Dropdown
                parentclasses="col-lg-3 col-md-4 col-sm-6 mont"
                value={filterData.year}
                onChange={handleYearChange}
                options={getYearOptions()}
                placeholder="Year"
              />

              <div className="col-lg-6 col-md-12  col-sm-12 d-flex justify-content-end gap-3 responsm">
                <Button
                  label={viewMode === "monthly" ? "Weekly View" : "Monthly View"}
                  style={{
                    border: "1px solid black",
                    backgroundColor: "transparent",
                    color: "#000",
                    fontSize: "12px",
                  }}
                  onClick={handleViewModeToggle}
                />
                <Button label="Excel File" />
              </div>
            </div>
          </div>
        </div>
        <div className="row pt-3">
          <div className="col-lg-8 col-md-8 col-sm-12 attendancerepoart gap-2">{renderData()}</div>
          <div className="col-lg-4 col-md-4 d-flex justify-content-end  mont">
            <Button label="Update Attendance" onClick={() => setOpen(true)} />
          </div>
        </div>
        <div className="row pt-3">
          <div className="col-lg-12">
            {viewMode === "monthly" ? (
              <MainContentReport reportData={reportData} startDate={startDate} message={message} />
            ) : (
              <WeeklyAttendance reportData={showWeeklyMonthlyData} startDate={startDate} message={message} />
            )}
          </div>
        </div>
        <CommonModal open={open} onClose={() => setOpen(false)} size="sm" title={"Update Attendance"}>
          <div className=" row-lg-12 p-5 ">
            <div className="col-lg-12 ">
              <Label label="Employee Name" />
              <Dropdown
                value={nameOptionValue}
                options={nameOption}
                onChange={(e) => setNameOptionValue(e.target.value)}
              />
            </div>
            <div className="col-lg-12">
              <Label label="Date" />
              <Input
                type="date"
                onChange={(e) => setOptionDate(e.target.value)}
                value={optionDate}
                max={today}
                min={firstDayOfMonth}
              />
            </div>
            <div className="col-lg-12">
              <Label label="Status" />
              <Dropdown
                type="text"
                options={attendanceTypeOption}
                onChange={(e) => setAttendanceOptionValue(e.target.value)}
                value={attendanceOptionValue}
              />
            </div>
          </div>
          <div className="py-3 d-flex justify-content-end pe-5 gap-2">
            <Button label="Reject" onClick={() => setOpen(false)} />
            <Button label="Update" onClick={() => updateEmployeeAttendance()} />
          </div>
        </CommonModal>
        <CoreLoader show={loading} />
      </div>
    </div>
  );
}

export default AttendanceReport;
